import React from "react";
import { Switch, Route, useParams, } from "react-router-dom";
import { Login } from "./auth/Login";
import { SignOut } from "./auth/SignOut";
import { RegisterType } from "./register/Index";
import { RegisterIndividual } from "./register/Individual";
import { RegisterSuccess } from "./register/Success";
import { FocusHeader } from "../common/header-and-footer/FocusHeader";
import { EditEventProcess } from "./edit-event/EditEventProcess";
import { EnrollProcess } from "./enroll/EnrollProcess";
import { RemoveEvent } from "./remove-event/RemoveEvent";
import { RegisterLegal } from "./register/Legal";
import { RegisterTrust } from "./register/Trust";
import { ForgottenPassword } from "./auth/ForgottenPassword";
import { ForgottenPasswordSent } from "./auth/ForgottenPasswordSent";
import { PasswordReset } from "./auth/PasswordReset";
import { PasswordSet } from "./auth/PasswordSet";
export const ProcessMaster = (props) => {
    const { urlEventId } = useParams();
    return (React.createElement("div", { className: "process-master" },
        React.createElement(FocusHeader, null),
        React.createElement("div", { className: "process-master-page" },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/cs/proces/registrace/dokonceno" },
                    React.createElement(RegisterSuccess, null)),
                React.createElement(Route, { path: "/cs/proces/registrace/fyzicka-osoba" },
                    React.createElement(RegisterIndividual, null)),
                React.createElement(Route, { path: "/cs/proces/registrace/pravnicka-osoba" },
                    React.createElement(RegisterLegal, null)),
                React.createElement(Route, { path: "/cs/proces/registrace/trust" },
                    React.createElement(RegisterTrust, null)),
                React.createElement(Route, { path: "/cs/proces/registrace" },
                    React.createElement(RegisterType, null)),
                React.createElement(Route, { path: "/cs/proces/odhlaseni" },
                    React.createElement(SignOut, null)),
                React.createElement(Route, { path: "/cs/proces/prihlaseni-uzivatele" },
                    React.createElement(Login, null)),
                React.createElement(Route, { path: "/cs/proces/zapomenute-heslo" },
                    React.createElement(ForgottenPassword, null)),
                React.createElement(Route, { path: "/cs/proces/heslo-odeslano" },
                    React.createElement(ForgottenPasswordSent, null)),
                React.createElement(Route, { path: "/cs/proces/reset-hesla/:urlHash" },
                    React.createElement(PasswordReset, null)),
                React.createElement(Route, { path: "/cs/proces/heslo-nastaveno" },
                    React.createElement(PasswordSet, null)),
                React.createElement(Route, { path: "/cs/proces/editovat-aukci/:urlEventId" },
                    React.createElement(EditEventProcess, { key: urlEventId })),
                React.createElement(Route, { path: "/cs/proces/zapsat-k-aukci/:urlEventId" },
                    React.createElement(EnrollProcess, { key: urlEventId })),
                React.createElement(Route, { path: "/cs/proces/odebrat-aukci/:urlEventId" },
                    React.createElement(RemoveEvent, { key: urlEventId }))))));
};
